const immunobiologicalInformationSchema = {
  immunobiologicalAbbreviation: {
    displayName: 'Abreviação do imunobiológico',
    type: 'string',
    notAvailable: 'Não informado',
  },
  immunobiologicalDescription: {
    displayName: 'Descrição do imunobiológico',
    type: 'string',
    notAvailable: 'Não informado',
  },
  vaccineDoseDescription: {
    displayName: 'Descrição da dose da vacina',
    type: 'string',
    notAvailable: 'Não informado',
  },
  administrationDateTime: {
    displayName: 'Data e hora da administração',
    notAvailable: 'Data e hora da administração não informada',
    mask: 'datetime',
  },
  vaccineBatch: {
    displayName: 'Lote da vacina',
    type: 'string',
    notAvailable: 'Não informado',
  },
  vaccineManufacturer: {
    displayName: 'Fabricante da vacina',
    type: 'string',
    notAvailable: 'Não informado',
  },
  attendanceGroup: {
    displayName: 'Grupo de atendimento',
    type: 'string',
    notAvailable: 'Não informado',
  },
  professionalName: {
    displayName: 'Nome do profissional de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  healthUnitName: {
    displayName: 'Nome da unidade de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  teamName: {
    displayName: 'Nome da equipe de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
}

export default immunobiologicalInformationSchema
